export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Qué recibo?',
    answer:
      'Recibís el contenido digital correspondiente a la oferta que elijas.',
  },
  {
    question: '¿Es un producto físico?',
    answer:
      'No. Carpintería Plegable PRO™ es un producto 100% digital.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Después de confirmar tu compra recibirás las instrucciones para acceder al contenido digital.',
  },
  {
    question: '¿Necesito ser carpintero profesional?',
    answer:
      'No necesariamente. Tener conocimientos básicos y saber utilizar correctamente las herramientas facilitará la realización de los proyectos.',
  },
  {
    question: '¿Es una suscripción?',
    answer: 'No. Ambas opciones son de pago único.',
  },
]
